import React from "react"
import Confirm from "./Confirm"
import WelcomeModal from "./WelcomeModal"
import { ModalsKeys } from "./ModalTypes"
import type { ModalContextProps, ModalProps } from "./ModalTypes"

export type { ModalContextProps, ModalProps } from "./ModalTypes"
export { ModalsKeys } from "./ModalTypes"

export default { Confirm, WelcomeMessage: WelcomeModal, None: null } as {
    [key in ModalsKeys]: React.FC<ModalProps> | null
}
